import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
  // 画面上に表示されたときに.is-animationを付与する要素
  var elements = $(".scrollAnm");

  elements.each(function () {
    var element = $(this);

    // GSAPのスクロールトリガーを設定
    gsap.to(element, {
      scrollTrigger: {
        trigger: element,
        start: "top 90%", // 要素が画面の75%に到達したときにトリガーします
        onEnter: function () {
          element.addClass("is-animation"); // クラスを追加
        }
      },
    });

    // ページ読み込み時に画面上に表示されているかチェック
    if (isElementInViewport(element)) {
      element.addClass("is-animation"); // クラスを追加
    }
  });

  // 要素が画面上に表示されているかどうかを判定する関数
  function isElementInViewport(el) {
    var rect = el[0].getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
});

function applyScrollAnimations() {
  const animatedElements = gsap.utils.toArray('[data-animation]');

  const animationHandlers = {
    scrollFade: (element, delay) => gsap.fromTo(element,
      { opacity: 0 },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          toggleActions: "play none none none",
          once: true,
        },
        duration: 0.8,
        ease: 'cubic-bezier(.25, .1, .25, 1)',
        delay: delay,
      }
    ),
    // 他のアニメーションタイプを追加
  };

  animatedElements.forEach(element => {
    const animationType = element.getAttribute('data-animation');
    const animationDelayType = element.getAttribute('data-animationDelay');
    if (animationType in animationHandlers) {
      if (animationDelayType === 'child') {
        const children = gsap.utils.toArray(element.children);
        children.forEach((child, index) => {
          animationHandlers[animationType](child, index * 0.1); // 子要素ごとの遅延を適用
        });
      } else {
        animationHandlers[animationType](element, 0); // 要素に直接アニメーションを適用
      }
    }
  });
}
document.addEventListener('DOMContentLoaded', applyScrollAnimations);